import homeModule from '../scripts/home/home.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(homeModule);